import { api } from './http';

export interface VapidPublicKeyResponse {
  public_key: string;
  configured: boolean;
}

/** P3-A12/Task 4's public endpoint — no auth required, since the frontend
 * needs the key before it can even call PushManager.subscribe(). */
export const getVapidPublicKey = () =>
  api.get<VapidPublicKeyResponse>('/push/public-key').then((r) => r.data);

export const subscribePush = (subscription: PushSubscriptionJSON, userAgent: string) =>
  api.post('/push/subscribe', {
    endpoint: subscription.endpoint,
    keys: { p256dh: subscription.keys?.p256dh, auth: subscription.keys?.auth },
    user_agent: userAgent,
  }).then((r) => r.data);

export const unsubscribePush = (endpoint: string) =>
  api.post('/push/unsubscribe', { endpoint }).then((r) => r.data);
